import React, { useContext, useEffect } from "react";
import "./statusZonePage.css";
import TopBar from "../../../components/TopBarComponent/Topbar";
import { Container } from "react-bootstrap";
import { StatusZoneContext } from "../StatusZoneView";
import LeftArrow from "../../../assets/images/leftArrow.svg";
import DataTable from "../../../components/DataTableComponent/DataTable";
import { Tabs, Tab } from "react-bootstrap";
import ExcelIcon from "../../../assets/images/Icons/xlIcon.svg";
import { baseURL } from "../../../api/Axios";
import { Spinner } from "react-bootstrap";
import AlertBox from "../../../components/AlertComponent/AlertBox";

const StatusZonePage = ({ textContents }) => {
  const {
    goBack,
    excelDownload,
    statusZone,
    getStatusZoneData,
    memberList,
    zoneNewExcel,
    pageCount,
    onPageChange,
    pageNumber,
    changeActiveZone,
    dataLoad,
    spinnerStatus,
    showAlert,
    statusCode,
    alertMessage,
    setShowAlert,
    logout,
  } = useContext(StatusZoneContext);
  const deviceSettingsHeader = [
    {
      title: "Name & Contact",
      prop: "empName",
      cell: (row) => (
        <div className="ertHeaderEvacuation">
          <div>{row.empName}</div>
          <span>{row.contact}</span>
        </div>
      ),
    },
    { title: "Employee Code", prop: "empCode" },
    { title: "Category", prop: "CategoryFName" },
    { title: "Working Unit", prop: "WorkingUnit" },
    // { title: "Contact No", prop: "contact" },
  ];

  return (
    <div className="status-zone">
       {dataLoad && (
        <div className="spinner-overlay-report">
          <Spinner size="xl" className="custom-spinner-report" />
        </div>
      )}
      <TopBar />
      <Container>
        <div className="zonePositingTop">
          <div className="heading-row my-3">
            <div className="title-box">
              <img
                className="back-arrow"
                src={LeftArrow}
                alt="Back Arrow"
                width={17}
                onClick={() => goBack()}
              />
              <p className="title-name">{"Filtered by Zone"}</p>
            </div>
            <div className="text-align"></div>
          </div>
          <Tabs
            defaultActiveKey="1"
            onSelect={(e) => {
              changeActiveZone(e);
            }}
          >
            <Tab eventKey="1" title={"PVC COMPOUNDING(ZONE 1)"}>
              <div className="topExcelRight">
                <span className="download-text">
                  <a
                    className="excel-download"
                    href={
                      zoneNewExcel ? `${baseURL}/excel/${zoneNewExcel}` : null
                    }
                  >
                    <img
                      className="excel-icon"
                      src={ExcelIcon}
                      alt="Excel-icon"
                    />
                    {spinnerStatus ? <Spinner size="sm" /> : "Download Excel"}
                  </a>
                </span>
              </div>
              <DataTable
                // loadingStatus={dataLoad}
                tableData={memberList}
                header={deviceSettingsHeader}
                pageCount={pageCount}
                currentPage={pageNumber}
                onPageChange={(e) => {
                  onPageChange(e);
                }}
              />
            </Tab>
            <Tab eventKey="2" title={"WIRES FACTORY(ZONE 2)"}>
              <div className="topExcelRight">
                <span className="download-text">
                  <a
                    className={
                      zoneNewExcel ? "excel-download" : "disabled-button"
                    }
                    href={
                      zoneNewExcel ? `${baseURL}/excel/${zoneNewExcel}` : null
                    }
                  >
                    <img
                      className="excel-icon"
                      src={ExcelIcon}
                      alt="Excel-icon"
                    />
                    {spinnerStatus ? <Spinner size="sm" /> : "Download Excel"}
                  </a>
                </span>
              </div>
              <DataTable
                // loadingStatus={dataLoad}
                tableData={memberList}
                header={deviceSettingsHeader}
                pageCount={pageCount}
                currentPage={pageNumber}
                onPageChange={(e) => {
                  onPageChange(e);
                }}
              />
            </Tab>
          </Tabs>
        </div>
      </Container>
      <AlertBox
        show={showAlert}
        setShow={setShowAlert}
        alertMessage={alertMessage}
        handleSubmit={
          statusCode == 401 ? () => logout() : () => setShowAlert(false)
        }
      />
    </div>
  );
};

export default StatusZonePage;
